import {
  getState as getReservationState,
  getGuestsByDeparture,
} from '../reservation/selectors';

export const FOCUS_SET = 'FOCUS_SET';
export const FOCUS_CLEAR = 'FOCUS_CLEAR';
export const FOCUS_MOVE = 'FOCUS_MOVE';

export const setFocus = (guestId, field, departureId) => ({
  type: FOCUS_SET,
  payload: {
    guestId,
    field,
    departureId,
  },
});

export const clearFocus = () => ({
  type: FOCUS_CLEAR,
});

export const moveFocus = direction => (dispatch, getState) => {
  const state = getState();
  const focusState = state.focus;
  const departureId = focusState.departureId;

  const reservationState = getReservationState(state);
  const guests = getGuestsByDeparture(reservationState, departureId);

  dispatch({
    type: FOCUS_MOVE,
    payload: {
      direction,
      guests,
    },
  });
};



// WEBPACK FOOTER //
// ./src/store/focus/actions.js